import { Box } from '@chakra-ui/react';
import { subMonths } from 'date-fns';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Heading from 'components/_core/Heading';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import OBUpload from 'features/Onboarding/components/OBUpload';
import { getUploadKybFunction } from 'features/Storage/upload';
import { formatDate } from 'helpers/date';

import Button from '../../../../../../components/_core/Button';
import FileUpload from '../../../../../../components/_core/FileUpload';
import Text from '../../../../../../components/_core/Text';
import { FILE_SIZE } from '../../../../legacy/components/TreezorUpload';
import getCompanyPapersDocumentType from '../../libs/getCompanyPapersDocumentType';
import { KybDocumentFile } from '../../machine/model';
import { KBIS_HELP_URL, SIRENE_HELP_URL } from './constants';
import getLocales from './locales';

interface CompanyPapersUploadProps {
  isEi: boolean;
  onUploadComplete: (documentFile: KybDocumentFile) => void;
  companyProfileId: string;
}

const CompanyPapersUpload = asBentoPage<CompanyPapersUploadProps>(
  ({ companyProfileId, isEi, Layout, onPrev, onUploadComplete }) => {
    const locales = getLocales(isEi);

    return (
      <Layout
        data-testid="company-papers-upload"
        nav={<OBNavigation onPrev={onPrev} />}
      >
        <Box>
          <Heading marginBottom="space-24" size="lg">
            {locales.title}
          </Heading>
          <Text>{locales.description}</Text>
          <Button
            as="a"
            href={isEi ? SIRENE_HELP_URL : KBIS_HELP_URL}
            icon="information"
            iconPosition="right"
            marginY="space-24"
            target="_blank"
            variant="inline-secondary"
          >
            {locales.link}
          </Button>

          <FileUpload
            maxByteSizeParam={FILE_SIZE.SUPPORTING_DOCUMENTS}
            onSuccessfulUpload={async ({ bucketName, fileRef, url }) =>
              onUploadComplete({
                firebaseBucket: bucketName,
                firebaseRef: fileRef,
                type: getCompanyPapersDocumentType({
                  isEi,
                }),
                url,
              })
            }
            uploadFile={getUploadKybFunction(companyProfileId)}
          />

          <OBUpload.Checklist
            checks={[
              locales.formatString(locales.checkIssueDate, {
                earliestIssueDate: formatDate(subMonths(new Date(), 3), 'PPP'),
              }) as string,
            ]}
            description={locales.aboutTheRules}
          />
        </Box>
      </Layout>
    );
  },
);

export default CompanyPapersUpload;
